class fileChangeDirective {

	constructor() {
		"ngInject";
		this.restrict = "A";
	}

	/**
	 *
	 * @param scope
	 * @param element
	 */
	link(scope, element) {
		element.on("change", (evt) => {
			// Перевіряємо, чи є upload компонент у скоупі
			// Якщо є - викликаємо тільки його, щоб уникнути подвійного виклику
			if (scope.upload && typeof scope.upload.$onSubmit === "function") {
				scope.$applyAsync(() => scope.upload.$onSubmit(evt));
			} else {
				// Якщо upload компонента немає, викликаємо стандартний submit
				element.parent().triggerHandler("submit", evt);
			}
		});
	}

	static create() {
		return new fileChangeDirective(...arguments);
	}

}

export {fileChangeDirective};



// WEBPACK FOOTER //
// ./sources/utility/file-change/file-change.directive.js